import { redirectToBackOfficeSso } from 'lib/helpers/redirectTo';
import { permissions } from 'config/settings/permissions';

import BackofficeLogo from 'assets/icons/BackofficeLogo.svg';
import grmt from 'assets/media/slider/GRMT.png';
import aml from 'assets/media/slider/AML&RG.png';
import lcrmt from 'assets/media/slider/LCRMT.png';
import srmt from 'assets/media/slider/SRMT.png';
import crmt from 'assets/media/slider/CRMT.png';

export default [
  {
    id: 'srmt',
    main: true,
    path: '/srmt',
    text: 'SRMT',
    img: srmt,
    handler: null,
    permission: permissions.SRMTBox
  },
  {
    id: 'crmt',
    main: true,
    path: '/crmt',
    text: 'CRMT',
    img: crmt,
    handler: null,
    permission: permissions.CRMTBox
  },
  {
    id: 'lcrmt',
    main: true,
    path: '/lcrmt',
    text: 'LCRMT',
    img: lcrmt,
    handler: null,
    permission: permissions.LCRMTBox
  },
  {
    id: 'aml',
    main: true,
    path: '/aml',
    text: 'AML & RG',
    img: aml,
    handler: null,
    permission: permissions.AMLBox
  },
  {
    id: 'grmt',
    main: true,
    path: '/grmt',
    text: 'GRMT',
    img: grmt,
    handler: null,
    permission: permissions.GeneralBox
  },
  {
    id: 'backOffice',
    main: false,
    handler: redirectToBackOfficeSso,
    text: 'BackOffice',
    permission: null,
    path: '',
    icon: BackofficeLogo
  }
];
